module.exports = __webpack_public_path__ + "static/media/HEART-5.98f00e02.svg";